export class SSOUSERI {
  businessPhones: string[];
  displayName: string;
  givenName: string;
  jobTitle: string;
  mail: string;
  mobilePhone: string;
  officeLocation: string;
  preferredLanguage: string;
  surname: string;
  userPrincipalName: string;
  id: string;
}

export class User {
  userId: String;
  userName: String;
  ssoUser: SSOUSERI;

  constructor(userId?: String, name?: String) {
    this.userId = userId;
    this.userName = name;
    this.ssoUser = new SSOUSERI();
  }

  setssoUserDetails(ssoUser: SSOUSERI) {
    this.ssoUser = ssoUser;
  }
}

export interface IBasicAuthUserTokenPayload {
  email: string;
  userName: string;
  isAdmin: boolean;
  isUserActive: boolean;
  isFirstLogin: boolean;
  isLoggedIn: boolean;
  iat: number; // Issued at
  exp: number; // Expiration time
}

export interface IBasicAuthUserBackendTokenPayload {
  username: string;
  // name: string;
  isAdmin: number;
  isUserActive: number;
  isFirstLogin: number;
  // isLoggedIn: number;
  iat: number; // Issued at
  exp: number; // Expiration time
}

export class BasicAuthUserTokenPayload implements IBasicAuthUserTokenPayload {
  email: string;
  userName: string;
  isAdmin: boolean;
  isUserActive: boolean;
  isFirstLogin: boolean;
  isLoggedIn: boolean;
  iat: number; // Issued at
  exp: number; // Expiration time

  constructor(data: IBasicAuthUserTokenPayload) {
    this.email = data.email;
    this.userName = data.userName;
    this.isAdmin = data.isAdmin;
    this.isUserActive = data.isUserActive;
    this.isFirstLogin = data.isFirstLogin;
    this.iat = data.iat;
    this.exp = data.exp;
  }

  // Helper method to check if the token is expired
  isTokenExpired(): boolean {
    const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
    return currentTime > this.exp;
  }
}
